import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PrintProductionDto } from '../../../../../model/print-production/print-production-dto';
import Pageable from '../../../../../model/pageable';

@Injectable({
  providedIn: 'root',
})
export class PrintProductionRequestService {
  private static BASE_URL = '/api/printproduction';

  constructor(private http: HttpClient) {}

  private get<T>(path: string, params?: any): Observable<HttpResponse<T>> {
    return this.http.get<T>(
      `${PrintProductionRequestService.BASE_URL}${path}`,
      {
        params,
        observe: 'response',
      }
    );
  }

  private put<T>(path: string, body: any): Observable<T> {
    return this.http.put<T>(
      `${PrintProductionRequestService.BASE_URL}${path}`,
      body
    );
  }

  private post<T>(body: any): Observable<T> {
    return this.http.post<T>(`${PrintProductionRequestService.BASE_URL}`, body);
  }

  private delete<T>(path: string): Observable<T> {
    return this.http.delete<T>(
      `${PrintProductionRequestService.BASE_URL}${path}`
    );
  }

  public getAllPrintProductions(
    filters: string = '',
    pageable: Pageable,
    showArchived: boolean = false
  ): Observable<{
    totalItems: number;
    printProductionItems: PrintProductionDto[];
  }> {
    // Construct query parameters based on the provided structure
    const filtersParam = `filters=${filters}`;
    const pageableParam = `page=${pageable.page}&size=${pageable.size}`;
    const showArchivedParam = `showArchived=${showArchived}`;

    // Combine all query parameters into a single query string
    const queryParams = `?${filtersParam}&${pageableParam}&${showArchivedParam}`;

    return this.get<PrintProductionDto[]>(queryParams).pipe(
      map((response) => {
        // Extract headers
        const totalItems = Number.parseInt(
          response.headers.get('X-Total-Count') || '0'
        );

        // Deserialize the body into the desired format
        const printProductionItems = response.body as PrintProductionDto[];

        return { totalItems, printProductionItems };
      })
    );
  }

  public updatePrintProduction(
    id: number,
    printProductionDto: PrintProductionDto
  ): Observable<PrintProductionDto> {
    return this.put<PrintProductionDto>(`/${id}`, printProductionDto);
  }

  public createPrintProduction(
    printProductionDto: PrintProductionDto
  ): Observable<PrintProductionDto> {
    return this.post<PrintProductionDto>(printProductionDto);
  }

  public deletePrintProduction(id: number): Observable<void> {
    return this.delete<void>(`/${id}`);
  }
}
